var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishedUnlocks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1347 9.67493C106.137 5.84993 125.369 11.1149 139.705 22.4887C145.504 27.0899 150.519 32.6981 154.307 39.0656C162.739 53.2378 165.439 70.4193 163.375 86.7796C161.31 103.14 154.69 118.71 145.715 132.542C138.836 143.139 130.415 152.947 119.837 159.857C109.259 166.767 96.3528 170.595 83.8484 168.789C73.0062 167.223 63.1006 161.575 54.6912 154.552C36.1175 139.03 23.8803 116.255 20.7584 92.2527C18.3312 73.5806 21.6444 53.4909 33.305 38.7084C46.1975 22.3649 66.8356 14.8949 86.3881 10.0743C86.9703 9.93087 87.5525 9.79868 88.1347 9.67493Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.955 135C112.955 135 93.1692 134.972 65.8047 134.972C60.8074 134.972 57.2117 130.917 57.2117 127.312C57.2953 113.637 56.25 113.637 56.25 99.9597C56.25 96.3566 60.8074 92.8125 65.8247 92.8125C93.1274 92.8125 85.6104 94.0791 112.977 94.0791C117.972 94.0791 120.297 98.0922 120.297 98.0922C120.297 98.0922 121.712 123.407 120.335 128.983C118.958 134.559 112.955 135 112.955 135Z",
    fill: "#F4526B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1313 15.5308C41.7653 16.5489 7.43876 52.5292 8.4597 95.8923C9.44688 137.821 43.2025 171.577 85.1313 172.564C128.497 172.564 172.288 128.616 172.288 85.4073C172.251 45.5626 132.685 15.5308 85.1313 15.5308Z",
    stroke: "#393B46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6408 106.876C86.6633 106.949 84.3064 109.527 84.3765 112.633C84.4443 115.637 86.762 118.055 89.6408 118.126C92.6183 118.126 95.625 114.977 95.625 111.882C95.6225 109.027 92.9059 106.876 89.6408 106.876Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9383 89.2626C75.9383 89.2626 70.5928 72.2653 75.9383 63.9501C84.2534 51.0154 112.202 48.8914 115.313 63.9501C115.956 67.0618 115.313 72.0863 115.313 72.0863",
    stroke: "#393B46",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118.125C90 120.375 90 129.375 90 133.594",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.375 77.3438L139.219 67.5",
    stroke: "#393B46",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.82 88.1396L142.99 93.2663",
    stroke: "#393B46",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.42 142.701C115.42 142.701 94.7744 142.668 66.2201 142.668C61.0056 142.668 57.2535 137.801 57.2535 133.476C57.3407 117.065 56.25 117.065 56.25 100.653C56.25 96.329 61.0056 92.0762 66.241 92.0762C94.7307 92.0762 86.887 93.5961 115.443 93.5961C120.656 93.5961 123.081 98.4118 123.081 98.4118C123.081 98.4118 124.559 128.789 123.122 135.481C121.685 142.172 115.42 142.701 115.42 142.701Z",
    stroke: "#393B46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedUnlocks);
export default __webpack_public_path__ + "static/media/finished-unlocks.4f4d0fc7505f86c11258145ab19e0703.svg";
export { ForwardRef as ReactComponent };